// src/contexts/HomePreferencesContext.js
import React, { createContext, useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

// Create the context object
export const HomePreferencesContext = createContext({
  homePreferences: null,
  loading: true,
});

// Provider component
export function HomePreferencesProvider({ children }) {
  const [homePreferences, setHomePreferences] = useState(null);
  const [loading, setLoading] = useState(true);
  const homePreferencesId = 'default';

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, 'home_preferences', homePreferencesId),
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.data();
          setHomePreferences({
            id: snapshot.id,
            heroTitle: data.hero_title || '',
            heroSubtitle: data.hero_subtitle || '',
            displayStyle: data.display_style || 'grid',
            showCarousel: data.show_carousel !== undefined ? data.show_carousel : true,
            heroBackgroundImageURL: data.hero_background_image_url || null,
          });
        } else {
          // No defaults - set null if document doesn't exist
          setHomePreferences(null);
        }
        setLoading(false);
      },
      (error) => {
        console.error('Error fetching home preferences:', error);
        // No defaults on error
        setHomePreferences(null);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [homePreferencesId]);

  return (
    <HomePreferencesContext.Provider value={{ homePreferences, loading }}>
      {children}
    </HomePreferencesContext.Provider>
  );
}
